import React, { useState } from 'react';
import { Plus, Save, X, Package, DollarSign, Layers, Users, Check } from 'lucide-react';
export function AddProduct() {
  const [fulfillment, setFulfillment] = useState('NiishEngine Design Team');
  return <div className="max-w-4xl mx-auto space-y-8" data-id="element-1634">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1635">
        <div className="flex items-center gap-4" data-id="element-1636">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-1637">
            <Package size={24} data-id="element-1638" />
          </div>
          <div data-id="element-1639">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-1640">
              Create Custom Service
            </h1>
            <p className="text-sm text-gray-500 font-medium" data-id="element-1641">
              Define your own partner services and fulfillment rules.
            </p>
          </div>
        </div>
        <div className="flex gap-3" data-id="element-1642">
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1643">
            <Save size={18} data-id="element-1644" />
            Save Product
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1645">
        <div className="md:col-span-2 space-y-6" data-id="element-1646">
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-1647">
            <div className="space-y-2" data-id="element-1648">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1649">
                Product Name
              </label>
              <input type="text" placeholder="e.g. Monthly SEO Audit" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1650" />
            </div>

            <div className="space-y-2" data-id="element-1651">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1652">
                Description
              </label>
              <textarea placeholder="Describe the service value..." className="w-full h-32 p-4 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none resize-none" data-id="element-1653" />
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-1654">
              <div className="space-y-2" data-id="element-1655">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1656">
                  Retail Price
                </label>
                <div className="relative" data-id="element-1657">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold" data-id="element-1658">
                    $
                  </span>
                  <input type="number" placeholder="0.00" className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1659" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-1660">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1661">
                  Billing Cycle
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-1662">
                  <option data-id="element-1663">One-time</option>
                  <option data-id="element-1664">Monthly Recurring</option>
                  <option data-id="element-1665">Annual Recurring</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-1666">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1667">
              Fulfillment Category
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-1668">
              {[{
              id: 'NiishEngine Design Team',
              icon: Layers,
              desc: 'Automated fulfillment by NiishEngine experts.'
            }, {
              id: 'Partner Self-Fulfill',
              icon: Users,
              desc: 'You handle the delivery and support.'
            }].map(item => <button key={item.id} onClick={() => setFulfillment(item.id)} className={`p-4 rounded-lg border-2 text-left transition-all ${fulfillment === item.id ? 'border-indigo-600 bg-indigo-50/50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-1669">
                  <div className="flex items-center justify-between mb-2" data-id="element-1670">
                    <item.icon size={20} className={fulfillment === item.id ? 'text-indigo-600' : 'text-gray-400'} data-id="element-1671" />
                    {fulfillment === item.id && <Check size={16} className="text-indigo-600" data-id="element-1672" />}
                  </div>
                  <p className="text-sm font-bold text-slate-900" data-id="element-1673">{item.id}</p>
                  <p className="text-[10px] text-gray-500 font-medium mt-1" data-id="element-1674">
                    {item.desc}
                  </p>
                </button>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-1675">
          <div className="bg-slate-900 p-6 rounded-lg text-white space-y-4" data-id="element-1676">
            <h3 className="text-sm font-bold" data-id="element-1677">Profit Preview</h3>
            <div className="space-y-3" data-id="element-1678">
              <div className="flex justify-between text-xs" data-id="element-1679">
                <span className="text-slate-400" data-id="element-1680">Retail Price</span>
                <span className="font-bold" data-id="element-1681">$0.00</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-1682">
                <span className="text-slate-400" data-id="element-1683">NiishEngine Fee</span>
                <span className="font-bold text-red-400" data-id="element-1684">-$0.00</span>
              </div>
              <div className="h-[1px] bg-slate-800" data-id="element-1685"></div>
              <div className="flex justify-between text-sm" data-id="element-1686">
                <span className="font-bold text-indigo-400" data-id="element-1687">Your Profit</span>
                <span className="font-bold text-indigo-400" data-id="element-1688">$0.00</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-1689">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-1690">Visibility</h3>
            <div className="flex items-center justify-between" data-id="element-1691">
              <span className="text-xs font-medium text-gray-500" data-id="element-1692">
                Publish to Storefront
              </span>
              <div className="w-10 h-5 bg-indigo-600 rounded-full relative" data-id="element-1693">
                <div className="absolute right-1 top-1 w-3 h-3 bg-white rounded-full" data-id="element-1694"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}